import * as actionTypes from './../types';
import { logger } from "@goldenbird1/ui-logger-library";
import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from "uuid";

export const setAuthLoading = (isLoading) => {
    return {
        type: actionTypes.SET_AUTH_LOADING,
        payload: {
            isLoading: isLoading
        }
    }
}


const encryptPassword = (password) => {
  const secretKey = process.env.NEXT_PUBLIC_REACT_APP_PASSWORD_SECRET_KEY;
  const finalsecretKey = CryptoJS.enc.Base64.parse(secretKey);
  
  // Encrypt the password
  // const encryptedPassword = CryptoJS.AES.encrypt(password, secretKey).toString();
  const encryptedPassword = CryptoJS.AES.encrypt(password, finalsecretKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
}).toString();
  return encryptedPassword;
};

export const setAuth = (authenticated, userAuth) => {
    return {
        type: actionTypes.SET_AUTH,
        payload: {
            authenticated: authenticated,
            userAuth: userAuth
        }
    }
}

export const getAccessToken = (values, callback) => async (dispatch) => {
    const url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + `/profile/v1/identity/users/token`;
    const encryptedPassword = encryptPassword(values.password);
    let data = {
      "clientId": process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_CLIENT_ID,
      "realm": process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_REALM,
      "tokenType": "access",
      "username": values.email,
      "grantType":"password",
      "password": encryptedPassword
    };

    fetch(
      url,
      {
        method : "POST",
        body : JSON.stringify(data),
        credentials:"include",
        headers : {
          "Content-Type": "application/json",
          'trace-id' : uuidv4()
        }
    }).then((res) => {
      if(res.ok){
        return res.json();
      } else {
        throw res;
      }
    }).then((resp) => {
      if(callback){
        callback(resp);
      }
      console.log(resp);
    }).catch((res) => {
      console.log('m here as well',res);
      res.json().then((errorMessage)=>{
        console.log("errorMessage",errorMessage)
        callback({ error: errorMessage})
      })
      // if(res.status === 401){
      //   callback({'status': 'unauthorized'})
      // } else {
      //   callback({ error: res });
      // }
    });
  }

export const getTokenFromRefreshToken = (rToken, callback) => async (dispatch) => {
    const url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + `/profile/v1/identity/users/token`;
    let data = {
      "clientId": process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_CLIENT_ID,
      "realm": process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_REALM,
      "tokenType": "refresh",
      "refreshToken": rToken
    };

    fetch(
      url,
      {
        method : "POST",
        body : JSON.stringify(data),
        credentials:"include",
        headers : {
          "Content-Type": "application/json",
          'trace-id' : uuidv4()
        }
    }).then((res) => {
      if(res.ok){
        return res.json();
      } else {
        throw res;
      }
    }).then((resp) => {
      if(callback){
        callback(resp);
      }
      console.log(resp);
    }).catch((res) => {
      console.log(res);
      if(res.status === 500){
        callback({'status': res.status});
      } else {
        callback({ error: res });
      }
    });
  }

  export const getAccessTokenSocial = (code, callback) => async (dispatch) => {
    let data = {
      "clientId": process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_CLIENT_ID,
      "tokenType": "code",
      "code": code,
      "redirectUri": process.env.NEXT_PUBLIC_REACT_APP_REDIRECT_APP_DOMAIN
    }
       const url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + `/profile/v1/identity/users/token`;
    fetch(
      url,
      {
        method : "POST", 
        body : JSON.stringify(data),
        credentials:"include",
        headers : {
          "Content-Type": "application/json",
          'trace-id' : uuidv4()
        }
    }).then((res) => {
      if(res.ok){
        return res.json();
      } else {
        throw res;
      }
    }).then((resp) => {
      if(callback){
        callback(resp);
      }
      console.log(resp);
    }).catch((err) => {
      console.log(err);
      if(err.status === 500){
        callback({'status': err.status});
      } else {
        callback({ error: err });
      }
    });
  }

export const keycloakLogout = (token, buyerId, data, callback) => async (dispatch) => {
 let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + '/profile/identity/logout';
 
  try {
      const response = await fetch(url,{
          method: "POST",
            body : JSON.stringify(data),
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
              'trace-id' : uuidv4()
            }
      })
      const res = await response.text();
      callback(res);
  } catch (error) {
      logger("error", "Error from orderId api: " +url + ': error :' + error+': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
  }
}